import { useTr } from '../../context/langContext';
import LangToggle from '../../components/ui/lang-toggle';
import { ownerStrings } from '../../i18n/owner-strings';
import { webStrings } from '../../i18n/web-strings';

/** Shown when the session or the first backend call fails (bad token, API down, CORS). */
export default function StartupError({
    message,
    onRetry,
    onSignOut,
}: {
    message?: string | null;
    onRetry?: () => void;
    onSignOut?: () => void;
}) {
    const tr = useTr();
    return (
        <div className="relative flex min-h-screen items-center justify-center bg-bg px-6">
            <LangToggle className="absolute right-4 top-4 h-9 rounded-xl border border-line px-3 text-[12.5px] text-ink2" />
            <div className="w-full max-w-md rounded-2xl border border-line bg-surf2 p-7 text-center">
                <p className="text-base font-bold text-ink">{tr(webStrings, 'startupTitle')}</p>
                <p className="mt-3 text-sm leading-relaxed text-ink2">
                    {message || tr(webStrings, 'startupBody')}
                </p>
                <p className="mt-3 break-all font-mono text-2xs text-ink3">
                    {process.env.REACT_APP_API_SERVER_URL}
                </p>
                <div className="mt-6 flex justify-center gap-3">
                    {onRetry && (
                        <button
                            onClick={onRetry}
                            className="h-11 rounded-xl bg-owner px-5 text-sm font-semibold text-white"
                        >
                            {tr(webStrings, 'tryAgain')}
                        </button>
                    )}
                    {onSignOut && (
                        <button
                            onClick={onSignOut}
                            className="h-11 rounded-xl border border-line px-5 text-sm font-semibold text-ink"
                        >
                            {tr(ownerStrings, 'signOut')}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
